import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '@/store';
import { isAdmin } from '@/utils/roleHelpers';
import { env } from '@/config/env';

interface AdminRouteProps {
  children: React.ReactElement;
}

/**
 * Protected route wrapper for admin-only pages
 * Redirects non-admin users to dashboard
 */
const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, isAuthenticated } = useAppSelector((state) => state.auth);

  // Bypass guard when authentication is disabled (development mode)
  if (!env.authEnabled && !env.authorizationEnabled) {
    return children;
  }

  // If not authenticated, redirect to login (handled by AuthGuard)
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated but not admin, redirect to dashboard
  if (!user || !isAdmin(user.roles)) {
    return <Navigate to="/dashboard" replace />;
  }

  // User is admin, render the protected component
  return children;
};

export default AdminRoute;
